import Helper from './Helper';
import '../assets/scss/popup.scss';

class Popup {
    /**
     * Initialize the popup switcher
     */
    constructor() {
        /**
         * Is the popup already initialized
         *
         * @type {boolean}
         */
        this.initalized = false;

        /**
         * Is the popup openned
         *
         * @type {boolean}
         */
        this.opened = false;

        // Load required assets
        import("../assets/scss/popup.scss");
    }

    /**
     * Load flag for popup
     * 
     * @returns {HTMLDivElement}
     */
    load(linguise_switcher)
    {
        // Get current language
        const current_lang = linguise_switcher.available_languages.find((item) => item.code === linguise_switcher.current_language);

        const language_settings = linguise_switcher.language_settings;

        const elem = document.createElement('div');
        elem.id = 'linguise_floating_wrapper';
        elem.innerHTML = `<div class="linguise_switcher ${language_settings?.flag_shape === 'rectangular' ? 'linguise_flag_rectangular' : 'linguise_flag_rounded'}">
                            <a href="#" class="linguise_switcher_popup" data-linguise-switcher="floating">
                                ${Helper.renderFlag(language_settings, current_lang.code)}
                                ${Helper.renderLanguageName(language_settings, current_lang.code, current_lang.name, current_lang.original_name)}
                            </a>
                          </div>`;

        // Replace Linguise shortcode ([linguise]) to switcher
        Helper.replaceLinguiseShortcodeToSwitcher(language_settings?.position, elem, linguise_switcher);

        this.postLoad(linguise_switcher);

        return elem;
    }

    postLoad(linguise_switcher) {
        const popup_elements = document.querySelectorAll('[data-linguise-switcher="floating"]');
        popup_elements.forEach((popup_elem) => {
            if (popup_elem.__linguise_click_handled) {
                // Already have click handler, skip!
                return;
            }

            popup_elem.addEventListener('click', (e) => {
                e.preventDefault();
                this.click(linguise_switcher.language_settings, linguise_switcher);
            });
            popup_elem.__linguise_click_handled = true;
        });
    }

    /**
     * Click the flag to open popup
     */
    click(languageSettings, linguise_switcher)
    {
        const previewContent = document.getElementById('dashboard-live-preview');

        if (!previewContent) {
            if (this.initalized === true) {
                // Already initialized
                this.switch();
                return;
            }

            this.initalized = true;
        }

        // Order alphabetically with default language on top
        Helper.sort(linguise_switcher);

        const language_settings = (languageSettings && Object.keys(languageSettings).length > 0) ? languageSettings : linguise_switcher.language_settings;
        const languages_lists = Helper.getOrderedLanguageList(
            linguise_switcher.available_languages, linguise_switcher.default_language, language_settings?.language_flag_order
        );

        const popup_elem = document.createElement('div');
        popup_elem.innerHTML = `
            <a class="close" href="#"><span></span></a>
            <ul>
                ${languages_lists.map(language => {
                    const is_default_language = linguise_switcher.default_language === language.code;
                    return `
                            <li class="${is_default_language ? 'current' : ''}">
                                <a href="${Helper.getLanguageUrl(linguise_switcher, language.code)}">
                                   ${Helper.renderFlag(language_settings, language.code)}
                                   ${Helper.renderLanguageName(language_settings, language.code, language.name, language.original_name, true)}
                                </a>
                            </li>`;
                }).join('')}
            </ul>
`;
        popup_elem.id = 'linguise_popup';
        popup_elem.className = `linguise_switcher ${language_settings?.flag_shape === 'rectangular' ? 'linguise_flag_rectangular' : 'linguise_flag_rounded'}`;

        const popup_ul = popup_elem.querySelector('ul');
        if (popup_ul) {
            // Add pre_text and post_text
            if (language_settings?.pre_text) {
                const pre_wrap = document.createElement('p');
                pre_wrap.classList.add('linguise_pre_text');
                pre_wrap.innerHTML = language_settings.pre_text;
                // We append before <ul> tag
                popup_ul.parentNode.insertBefore(pre_wrap, popup_ul);
            }

            if (language_settings?.post_text) {
                const post_wrap = document.createElement('p');
                post_wrap.classList.add('linguise_post_text');
                post_wrap.innerHTML = language_settings.post_text;
                // We append after <ul> tag
                popup_ul.parentNode.appendChild(post_wrap);
            }
        }

        const popup_elem_parent = document.createElement('div');
        popup_elem_parent.id = 'linguise_popup_container';
        popup_elem_parent.appendChild(popup_elem);

        document.body.appendChild(popup_elem_parent);

        setTimeout(function () {
            popup_elem_parent.classList.add('show_linguise_popup_container');
        }, 100);

        const background_elem = document.createElement('div');
        background_elem.id = 'linguise_background';
        document.body.appendChild(background_elem);

        // Language color and hover
        const popupElements = document.getElementsByClassName('popup_linguise_lang_name');
        Helper.colorAndHoverLanguageName(language_settings, [], popupElements);

        document.querySelectorAll('#linguise_background, #linguise_popup .close').forEach(elem => elem.addEventListener('click', (e) => {
            e.preventDefault();
            this.switch();
        }));

        this.opened = true;
    }

    /**
     * Switch popup visibility
     */
    switch()
    {
        const previewContent = document.getElementById('dashboard-live-preview');

        if (!previewContent) {
            document.getElementById('linguise_background').style.display = this.opened ? 'none': '';
            document.querySelector('#linguise_popup_container').classList.toggle('show_linguise_popup_container');
            this.opened = !this.opened;
        } else {
            document.getElementById('linguise_background').remove();
            document.getElementById('linguise_popup_container').classList.remove('show_linguise_popup_container');
            setTimeout(() => {
                document.getElementById('linguise_popup_container').remove();
            }, 100);
            this.opened = false;
        }
    }

}

export default Popup;
